<template>
    <div>

        <h2 style="margin:10px 0px 10px 0px;">Settings</h2>
        <p>
            Configure your settings here.
        </p>
       
    </div>
</template>

<script>
  export default {
    name: 'account-settings',
    components: {
      
    },
    data() {
    },
      mounted() {
        //this.$refs["username"].focus()
      },
    computed: {
        count() {
            
        }
    },
    methods: {
    }
  }
</script>

<style scoped>
    h2 {
        font-size:24px;
    }
    table th {
        border-top:none;
        padding:5px 0px;
    }
    table td {
        padding:5px 0px;
    }
</style>


